import {inject, observer} from "mobx-react";
import React              from "react";
import withStyles         from "material-ui/styles/withStyles";

//core components
import GridContainer from "../../components/Grid/GridContainer";
import ItemGrid      from "../../components/Grid/ItemGrid";
import CustomInput from "../../components/CustomInput/CustomInput.jsx";
import IconCard         from "../../components/Cards/IconCard";
import Button           from "../../components/CustomButtons/Button";
import Table         from "../../components/Table/Table.jsx";
import {toJS}         from "mobx";
import * as FileSaver from 'file-saver';
import * as XLSX      from 'xlsx';
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../components/Pagination/Pagination";


// material-ui icons
import InsertDriveFile from '@material-ui/icons/InsertDriveFile';




import CircularProgress from "material-ui/Progress/CircularProgress";
import pink           from "material-ui/colors/pink";

import sessioneScattiStyle from "../../assets/jss/material-dashboard-pro-react/layouts/sessioneScattiStyle";
import '../../assets/css/editabletable.css'
import Cookies from "universal-cookie";
const cookies = new Cookies();

@inject('store')
@observer
class SessioneScatti extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sessioneScattiData:[
                ["", "", ""],
                ["", "", ""],
                ["", "", ""],
                ["", "", ""]
            ],
            fileType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
            fileExtension: '.xlsx',
            exportDataToCSV: true,
            showEmptyDataError:false,
            startIndex:0,
            finishIndex:5,
            page:1,
            rowPerPage:5
        };
        this.store = this.props.store.appState;
    }

    componentWillMount(){
        let self = this;

        // if(self.store.sessione_scatti_search_results === false){
        //     self.get_sessione_scatti_data(true);
        // }else{
        //     self.setState({dataUltimoDownload: self.store.sessione_scatti_search_results[0].lastDownloadDate});
        //     self.mapSessioneScattiData(self.store.sessione_scatti_search_results);
        // }
        self.get_sessione_scatti_data(true);
    }

    componentDidMount() {

    }

    componentDidUpdate() {

    }

    componentWillReceiveProps(props){

    }

    get_sessione_scatti_data(init=false){
        let self = this;
        self.setState({loading:true});
        const data = {
            project_id: self.store.project_id,
            token: self.store.token
        }
        self.store.get_data_sessione_scatti(data, function(res){
            if(res){
                self.store.dataUltimoDownload = res[0].lastDownloadDate;
                self.mapSessioneScattiData(self.store.sessione_scatti_search_results);
            }else{
                self.setState({
                    showEmptyDataError:true,
                    loading:false
                })
                // console.log('error');
            }
        });
    }


    mapSessioneScattiData(res){

        let self = this;
        let grupped_data = [];

        const teams = res.reduce((acc, item) => {
            if (!acc[item.Squadra]) {
                acc[item.Squadra] = [];
            }
            acc[item.Squadra].push(item);
            return acc;
        }, {})

        /// split category in different array for each team
        for (let key in teams){
            const category =  teams[key].reduce((acc, item) => {
                if (!acc[item.Categoria]) {
                    acc[item.Categoria] = [];
                }
                acc[item.Categoria].push(item);
                return acc;
            }, {})

            /// create new array of objects with team , category and count
            for(let key in category) {
                let obj= {}  ;
                obj.Squadra= category[key][0].Squadra;
                obj.Categoria= category[key][0].Categoria;
                let count = category[key].filter(item=>item.NomeFileFoto!=='').length;
                obj.count=count;
                grupped_data.push(obj)
            }
        }

        grupped_data = grupped_data.map((item, key) => {

            return [
                item["Squadra"],
                item["Categoria"],
                item["count"]
            ]
        });

        self.setState({sessioneScattiData:grupped_data, loading:false});
        let flagPage;
        if(grupped_data.length % self.state.rowPerPage ===0){
            flagPage = Math.floor(grupped_data.length/self.state.rowPerPage) ;
        } else {
            flagPage = Math.floor(grupped_data.length/self.state.rowPerPage) + 1;
        }
        self.store.flagPageSessioneScatti = flagPage;
    }

    hideAlert=()=>{
        this.setState({
            showEmptyDataError:false
        })
    }


    handleLastDataUploaded = () => {
        let self = this;
        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);
        const fileName = DEFAULT_TEXT.export_sessione_scatti_data_ultimi_filename;
        let exportData = [];


        self.setState({loading:true});

        const data = {
            project_id: self.store.project_id,
            token: self.store.token,
            downloadDate: self.store.dataUltimoDownload
        }


        self.store.get_last_data_sessione_scatti(data, function(res){

            if(res){

                res.map((item) => {
                    let obj = {
                        'Squadra': item.Squadra,
                        'Categoria': item.Categoria,
                        'Nome': item.Nome,
                        'Cognome': item.Cognome,
                        'NomeFileFoto': item.NomeFileFoto,
                        'ReferenteCategoria': item.ReferenteCategoria === 0 ? 'No':'Si' ,
                        'Email': item.EmailReferente,
                        'DataCaricamento': item.DataCaricamento ? item.DataCaricamento.replace('T', ' ').replace('.000Z', '') : item.DataCaricamento
                    };
                    exportData.push(obj);
                    return item;
                });

                const d = new Date();
                const date = d.toISOString().split('T')[0];
                const time = d.toTimeString().split(' ')[0];
                const downloadDate = `${date} ${time}`;

                // const ws = XLSX.utils.json_to_sheet(exportData);
                // const wb = {Sheets: {'data': ws}, SheetNames: ['data']};
                // const excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
                // const data = new Blob([excelBuffer], {type: self.state.fileType});
                // FileSaver.saveAs(data, fileName + self.state.fileExtension);

                // Update downloaded date
                self.store.update_download_date({
                    idProject: self.store.project_id,
                    token: self.store.token,
                    downloadDate: downloadDate
                }, function (res) {
                    if (res){
                        self.store.dataUltimoDownload = downloadDate;
                        const ws = XLSX.utils.json_to_sheet(exportData);
                        const wb = {Sheets: {'data': ws}, SheetNames: ['data']};
                        const excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
                        const data = new Blob([excelBuffer], {type: self.state.fileType});

                        const currentDate = new Date();
                        const currentDayOfMonth = currentDate.getDate();
                        const currentMonth = currentDate.getMonth();
                        const currentYear = currentDate.getFullYear();
                        const dateString = currentDayOfMonth + "-" + (currentMonth + 1) + "-" + currentYear;
                        FileSaver.saveAs(data, fileName +'-'+ dateString + self.state.fileExtension);
                    }else{
                        // console.log('error during downloadDate update');
                    }
                });

                self.setState({loading: false});
            }else{
                self.setState({
                    showEmptyDataError:true,
                    loading:false
                })
            }
        });
    }

    exportToCSV = (csvData) => {
        const self = this;
        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);

        const fileName = DEFAULT_TEXT.export_sessione_scatti_data_filename;

        if (csvData && csvData.length >= 0) {
            let exportData = [];

            csvData.map( (item) => {
                let obj = {
                    'Squadra': item.Squadra,
                    'Categoria': item.Categoria,
                    'Nome': item.Nome,
                    'Cognome': item.Cognome,
                    'NomeFileFoto': item.NomeFileFoto,
                    // 'ReferenteCategoria': item.ReferenteCategoria === 0 ? 'No':'Si',
                    // 'Email': item.EmailReferente,
                    // 'DataCaricamento': item.DataCaricamento ? item.DataCaricamento.replace('T', ' ').replace('.000Z', '') : item.DataCaricamento
                };
                exportData.push(obj);
                
                return item;
            });

            const d = new Date();
            const date = d.toISOString().split('T')[0];
            const time = d.toTimeString().split(' ')[0];
            const downloadDate = `${date} ${time}`;

            //Update downloaded date
            self.store.update_download_date({
                idProject: self.store.project_id,
                token: self.store.token,
                downloadDate: downloadDate
            }, function (res) {
                if (res){
                    self.store.dataUltimoDownload=downloadDate;
                    const ws = XLSX.utils.json_to_sheet(exportData);
                    const wb = {Sheets: {'data': ws}, SheetNames: ['data']};
                    const excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
                    const data = new Blob([excelBuffer], {type: self.state.fileType});

                    const currentDayOfMonth = d.getDate();
                    const currentMonth = d.getMonth();
                    const currentYear = d.getFullYear();
                    const dateString = currentDayOfMonth + "-" + (currentMonth + 1) + "-" + currentYear;
                    FileSaver.saveAs(data, fileName +'-'+ dateString + self.state.fileExtension);
                }else{
                    // console.log('error during downloadDate update');
                }
            });
        } else {
            this.setState({exportDataToCSV: false});
        }
    };

    goToNextPage = () => {
        this.setState({
            startIndex: this.state.startIndex + this.state.rowPerPage,
            finishIndex: this.state.finishIndex + this.state.rowPerPage,
            page:this.state.page+1
        });
    }

    goToPreviousPage = () => {
        this.setState({
                startIndex: this.state.startIndex-this.state.rowPerPage,
                finishIndex: this.state.finishIndex-this.state.rowPerPage,
                page:this.state.page-1
            }
        );
    }

    render() {


        const disable_download_lastUploadedData = Boolean(cookies.get('landing_page_status'));
        
        const { classes} = this.props;
        const { sessioneScattiData,showEmptyDataError,page,startIndex,finishIndex} = this.state;
        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);

        let finalData = sessioneScattiData.slice(startIndex,finishIndex);

        const sessioneScatti_tableHead = [
            DEFAULT_TEXT.ss_team_label,
            DEFAULT_TEXT.ss_category_label,
            DEFAULT_TEXT.ss_scatti_eff
        ];

        let pages = [];
        pages.push({ text: "PREV", onClick:this.goToPreviousPage, disabled:page<=1});
        pages.push({ active: true, text: this.state.page });
        pages.push({ text: "NEXT" , onClick:this.goToNextPage, disabled:page + 1 > this.store.flagPageSessioneScatti });


        return(
            <div>
                <GridContainer justify={"center"}>
                    <ItemGrid xs={12} sm={12} md={12}>
                        <ItemGrid xs={12} sm={12} md={12}>
                            <IconCard
                                icon={InsertDriveFile}
                                iconColor="rose"
                                title={DEFAULT_TEXT.sb_sessione_scatti}
                                content={
                                    <div>
                                        {
                                            !this.state.loading ?
                                                <div>
                                                    <Table
                                                        tableHeaderColor="primary"
                                                        tableHead={sessioneScatti_tableHead}
                                                        tableData={finalData}
                                                        coloredColls={[4]}
                                                        hover
                                                        colorsColls={["primary"]}
                                                    />
                                                    <div  className='pagination'>
                                                        <Pagination pages={pages} color="rose" />
                                                    </div>

                                                </div>
                                                :
                                                <div style={this.state.loading ? {display:"flex", justifyContent:"center"} : null}>
                                                    <CircularProgress className={classes.progress} style={{ color: pink[500]}}/>
                                                </div>
                                        }
                                    </div>
                                }
                            />
                        </ItemGrid>
                    </ItemGrid>

                    <ItemGrid xs={12} sm={8} md={6}>
                        <div style={{backgroundColor: 'white'}}>
                            <div className={classes.inputContainer}>
                                <div style={{marginLeft: '15px'}}>
                                    <p className={classes.downloadLabel}>
                                        {DEFAULT_TEXT.ss_last_edit_date.toUpperCase()}
                                    </p>
                                </div>
                                <div style={{/*backgroundColor: 'yellow',*/ width: '50%',}}>
                                    <CustomInput
                                        labelText=""
                                        id="data_ultimo_download"
                                        formControlProps={{
                                            fullWidth: false
                                        }}
                                        value={this.store.dataUltimoDownload}
                                        inputProps={{
                                            type: "text",
                                            value: this.store.dataUltimoDownload !== null ? this.store.dataUltimoDownload : '',
                                        }}
                                    />
                                </div>
                            </div>
                            <div className={classes.buttonsContainer}>
                                <div style={{marginLeft: '20px'}}>
                                    <Button
                                        color="rose"
                                        round
                                        size="sm"
                                        onClick={() => {this.exportToCSV(this.store.sessione_scatti_search_results, DEFAULT_TEXT.export_my_orders_filename)}}>{DEFAULT_TEXT.ss_btn_download_all.toUpperCase()}
                                    </Button>
                                </div>
                                <div style={{marginRight: '20px'}}>
                                    <Button
                                        disabled={!disable_download_lastUploadedData || this.store.dataUltimoDownload === null}
                                        round
                                        size="sm"
                                        color={!disable_download_lastUploadedData || this.store.dataUltimoDownload === null  ? 'primary': 'rose'}
                                        onClick={this.handleLastDataUploaded}>
                                        {DEFAULT_TEXT.ss_btn_last_updated_data.toUpperCase()}
                                    </Button>
                                </div>
                            </div>
                        </div>

                        {
                            showEmptyDataError ?
                                <div>
                                    <GridContainer justify={"center"}>
                                        <ItemGrid xs={12} sm={6}>
                                            <SweetAlert
                                                warning
                                                confirmBtnText = 'Ok'
                                                confirmBtnStyle ={{background:'red'}}
                                                title={
                                                    <div className={classes.alertMsg}>
                                                        {DEFAULT_TEXT.sessione_scattti_nodata_alert_msg}
                                                    </div>
                                                }
                                                onConfirm={this.hideAlert}
                                                confirmBtnCssClass={ this.props.classes.button + " " + this.props.classes.warning }>
                                            </SweetAlert>
                                        </ItemGrid>
                                    </GridContainer>
                                </div>
                                :
                                null
                        }
                    </ItemGrid>
                </GridContainer>
            </div>
        )
    }
}

export default withStyles(sessioneScattiStyle)(SessioneScatti);



// WEBPACK FOOTER //
// ./src/views/GestioneScatti/SessioneScatti.jsx